module.exports = __webpack_public_path__ + "img/file-img-xlsx.1a36a1f4.jpg";